// PurchaseTokenForm.js
import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../config/api';
import axios from 'axios';
import withAuthorization from "../components/authentication";
import "react-datepicker/dist/react-datepicker.css";
import Navbar from '../components/Navbar';
import { numberToWordsIndian } from '../utils/numberToWords';
import { openAndSaveInvoice } from '../utils/openAndSaveInvoice';
const PurchaseTokenForm = () => {
  const [ownerName, setOwnerName] = useState('');
  const [ownerWhatsApp, setOwnerWhatsApp] = useState('');
  const [carTitle, setCarTitle] = useState('');
  const [carRegistrationNumber, setCarRegistrationNumber] = useState('');
  const [tokenAmount, setTokenAmount] = useState('');
  const [approxDealAmount, setApproxDealAmount] = useState('');
 const [address,setaddress]= useState('');
  const [carModel, setCarModel] = useState('');
  const [message, setMessage] = useState('');
const [submissionSuccess, setSubmissionSuccess] = useState(false);
   const [loading, setLoading] = useState(false);

  // Blocks duplicate submissions; reset automatically when loading clears.
  const submittingRef = useRef(false);
  useEffect(() => {
    if (!loading) submittingRef.current = false;
  }, [loading]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Synchronous guard: blocks a second click in the same tick, which a
    // state check cannot do. Prevents duplicate invoices.
    if (submittingRef.current) return;
    submittingRef.current = true;
    setLoading(true);
    const formData = {
      ownerName,
      ownerWhatsApp,
      carTitle,
      carRegistrationNumber,
      tokenAmount,
      approxDealAmount,
      address,
      carModel
    };
 
    
  try {
    // Send ONLY JSON data. The backend generates the invoice PDF and returns its URL.
    const response = await axios.post(
      `${API_BASE_URL}/purchasetoken/create`,
      formData,
      { withCredentials: true }
    );

    // Open the invoice in a new tab and save a copy to disk.

    openAndSaveInvoice(response.data);

    // Notify the user
    setSubmissionSuccess(true);

    // Optionally, reset the form
   
  } catch (error) {
    console.error('Error submitting token:', error);
    alert('Failed to submit the token application. Please try again.');
  }
  finally {
    setLoading(false); // Set loading to false after submission completes
  }
    
  };
   // State to handle any errors
  // Invoice PDF is now generated entirely in the backend.

  return (
    <div><Navbar/><div className="max-w-lg mx-auto p-4 border rounded shadow-md">
    <h2 className="text-2xl font-bold mb-4"> Purchase Token Form</h2>
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative w-full p-4 border border-blue-700 rounded">
      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner Name</label>
        <input
          type="text"
          value={ownerName}
          onChange={(e) => setOwnerName(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner WhatsApp</label>
        <input
          type="text"
          value={ownerWhatsApp}
          onChange={(e) => setOwnerWhatsApp(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Title</label>
        <input
          type="text"
          value={carTitle}
          onChange={(e) => setCarTitle(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Registration Number</label>
        <input
          type="text"
          value={carRegistrationNumber}
          onChange={(e) => setCarRegistrationNumber(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Token Amount</label>
        <input
          type="number"
          value={tokenAmount}
          onChange={(e) => setTokenAmount(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mt-2">
        <label className="block text-sm font-semibold">Token Amount <strong>in Words</strong></label>
        <input
          type="text"
          value={numberToWordsIndian(Number(tokenAmount))}
         // onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
         // required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Approx Deal Amount</label>
        <input
          type="number"
          value={approxDealAmount}
          onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mt-2">
        <label className="block text-sm font-semibold">Approx Deal Amount in <strong>in Words</strong></label>
        <input
          type="text"
          value={numberToWordsIndian(Number(approxDealAmount))}
         // onChange={(e) => setApproxDealAmount(e.target.value)}
          className="w-full p-2 border rounded"
         // required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Owner Address</label>
        <input
          type="text"
          value={address}
          onChange={(e) => setaddress(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>

      <div className="mt-2">
        <label className="block text-sm font-semibold">Car Model</label>
        <input
          type="text"
          value={carModel}
          onChange={(e) => setCarModel(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      </div>

      <button type="submit"
        disabled={loading} className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600">
      {loading ?  (
         <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
    {/* Car Animation */}
    <div className="w-28 h-16 flex items-center justify-center mb-4">
      <img
        src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1754381777/Screenshot__620_-removebg-preview_20250805_134123_0000_2_gbdz3h.png"
        alt="Car Logo"
        className="w-36 h-16 animate-carDrive"
      />
    </div>

    {/* Loading Text */}
    <p className="text-xl md:text-2xl font-bold text-gray-800 text-center">
      Purchase Deal Form{' '}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
        is Submitting......
      </span>
    </p>
  </div>
        )  : (
          'Submit Token Form'
        )}
      </button>
      
    </form>

    {submissionSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-semibold text-green-600">Token Form Submitted Successfully!</h2>
            <p className="mt-2 text-gray-700">THANK YOU.</p>
            <button
              onClick={() => setSubmissionSuccess(false)}
              className="mt-4 px-6 py-2 bg-blue-500 text
              white rounded-lg hover:bg-blue-600 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
  </div></div>
  );
};

export default  withAuthorization(PurchaseTokenForm, ["admin", "Employee"]);;
